export default "__VITE_ASSET__CrKXrAII__"